var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map-offcanvas__item" }, [
    _vm._m(0),
    Object.keys(_vm.open_shelters_list).length > 0
      ? _c("div", { staticClass: "map-offcanvas__body" }, [
          _c(
            "div",
            { staticClass: "uk-padding-small uk-padding-remove-vertical" },
            [
              _c(
                "ul",
                {
                  staticClass: "uk-list uk-margin-remove",
                  attrs: { "uk-accordion": "" }
                },
                _vm._l(_vm.open_shelters_list, function(shelters, area_name) {
                  return _c("li", { key: "area_" + area_name }, [
                    _c(
                      "a",
                      {
                        staticClass: "uk-accordion-title",
                        attrs: { href: "#" }
                      },
                      [
                        _c("div", { staticClass: "uk-flex uk-flex-middle" }, [
                          _c("span", [_vm._v(_vm._s(area_name) + " ")]),
                          _c("span", { staticClass: "uk-badge" }, [
                            _vm._v(_vm._s(shelters.length))
                          ])
                        ])
                      ]
                    ),
                    _c("div", { staticClass: "uk-accordion-content" }, [
                      _c(
                        "ul",
                        { staticClass: "uk-list uk-list-square" },
                        _vm._l(shelters, function(shelter) {
                          return _c(
                            "li",
                            { key: "shelter_" + shelter.props.name },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.handlePopup(shelter)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(shelter.props.name))]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ])
      : _c("div", { staticClass: "map-offcanvas__body" }, [
          _vm._v("現在開設中の避難所はありません。")
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "map-offcanvas__title" }, [
      _c("span", { attrs: { "uk-icon": "icon: location; ratio: .7" } }),
      _c("div", [_vm._v(" 避難所情報")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }